export const positionElement = (
	pointer: { x: number; y: number },
	element: HTMLElement,
	where: string,
	elementClicked?: HTMLElement | undefined,
	adjustment?: { x: number; y: number }
) => {
	const x = pointer.x;
	const y = pointer.y;
	const w = window.innerWidth;
	const h = window.innerHeight;
	const adjustmentX = adjustment ? adjustment.x : 0;
	const adjustmentY = adjustment ? adjustment.y : 0;

	// position the element toward the middle of the screen
	// with a corner at the pointer location
	if (where === 'inner-corner') {
		if (x < w / 2 && y < h / 2) {
			// top left
			element.style.top = `${y}px`;
			element.style.left = `${x}px`;
		} else if (x > w / 2 && y < h / 2) {
			// top right
			element.style.top = `${y}px`;
			element.style.left = `${x - element.offsetWidth}px`;
		} else if (x < w / 2 && y > h / 2) {
			// bottom left
			element.style.top = `${y - element.offsetHeight}px`;
			element.style.left = `${x}px`;
		} else if (x > w / 2 && y > h / 2) {
			// bottom right
			element.style.top = `${y - element.offsetHeight}px`;
			element.style.left = `${x - element.offsetWidth}px`;
		}
	}

	// position the element down from the HTMLElement that was clicked,
	// disregarding the pointer location
	// but if it's too close to the bottom of the screen, open upward
	if (where === 'dropdown' && elementClicked) {
		const rect = elementClicked.getBoundingClientRect();
		const spaceBelow = h - (rect.bottom + element.offsetHeight);

		if (spaceBelow > 0) {
			// There's enough space below the clicked element
			element.style.top = `${adjustmentY + rect.bottom + window.scrollY}px`;
			element.style.left = `${
				adjustmentX + rect.left + window.scrollX + rect.width / 2 - element.offsetWidth / 2
			}px`;
		} else {
			// Not enough space below, open above the clicked element
			element.style.top = `${rect.top + window.scrollY - element.offsetHeight - adjustmentY}px`;
			element.style.left = `${
				adjustmentX + rect.left + window.scrollX + rect.width / 2 - element.offsetWidth / 2
			}px`;
		}
	}
};
